// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__MQn+-","card-img":"CardTile_card-img__-dsZ+"};